<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Tipos de movimiento de caja</h3>
      </div>
    </div>

    <div class="card">
      <div class="card__title">
        <h5>Consulta</h5>
        <div class="layout__controls">
          <div class="form-inline">
            <button
              type="button"
              @click="consultar('C')"
              class="btn-info btn--bigger"
            >
              <i class="fa fa-search"></i><span>Consultar</span>
            </button>
            <button
              type="button"
              @click="exportarDocumento1"
              class="btn-danger"
            >
              <i class="fa fa-file-pdf-o"></i><span>PDF</span>
            </button>
            <!-- <button
              type="button"
              @click="exportarExcel('C')"
              class="btn-success btn--bigger"
            >
              <i class="fa fa-file-excel-o"></i><span>Exportar</span>
            </button> -->
          </div>
        </div>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select v-model="form.tipo" name="Tipo" id="tipo">
                  <option value="T">Todos</option>
                  <option value="I">Ingresos</option>
                  <option value="G">Descuentos</option>
                </select>
                <label for="tipo">Tipos</label>
                <div class="layout__controls"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <k-table
          :deleteButton="puede_anular"
          :createButton="puede_crear"
          :editButton="false"
          ref="tipoGasto"
          @crear="crear"
          :path="path"
          @eliminar="eliminar"
          :params="form"
          :columns="[
            {
              display: 'Código',
              value: 'codigo',
            },
            {
              display: 'Tipo',
              value: 'descripcion_tipo',
            },
            {
              display: 'Tipo de aplicación',
              value: 'descripcion_tipo_aplicacion',
            },
            {
              display: 'Descripción',
              value: 'descripcion',
            },
            {
              display: 'Creador',
              value: 'creador.nombre',
            },
            {
              display: 'Fecha creación',
              value: 'created_at',
            },
            {
              display: 'Modificador',
              value: 'modificador.nombre',
            },
            {
              display: 'Fecha modificación',
              value: 'updated_at',
            },
          ]"
        ></k-table>
      </div>
    </div>
    <modal
      name="tipoGastoModal"
      scrollable
      resizable
      reset
      adaptive
      height="auto"
      width="60%"
    >
      <tipo-gasto
        @cancelar="cancelar"
        @saved="savedTipoGasto"
        ref="tipoGastoModal"
        v-model="selectedTipoGasto"
      ></tipo-gasto>
    </modal>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      form: {
        tipo: "T",
        exportarDocumento1: "P",
      },
      path: url + "/tipos-gastos",
      selectedTipoGasto: null,
      puede_anular: false,
      puede_crear: false,
    };
  },
  methods: {
    cargarDatos: function () {
      axios
        .get(this.path + "/datos")
        .then(({ data }) => {
          this.puede_anular = data.puede_anular;
          this.puede_crear = data.puede_crear;
        })
        .catch(() => {
          swal("Hubo un error al cargar los datos.", "Error", "error");
        });
    },
    exportarExcel: function () {},
    cancelar: function () {
      this.$modal.hide("tipoGastoModal");
    },
    savedTipoGasto: function () {
      this.$modal.hide("tipoGastoModal");
      this.$refs.tipoGasto.loadRows();
    },
    crear: function () {
      this.selectedTipoGasto = {
        codigo: "",
        descripcion: "",
        tipo: "",
        rol_pago: false,
        tipo_aplicacion: 'V'
      };
      this.$modal.show("tipoGastoModal");
    },
    consultar: function () {
      this.form.exportarDocumento = 'C';
      this.$refs.tipoGasto.loadRows();
    },
    exportarDocumento1: function () {
      this.form.exportarDocumento = 'P';
      window.open(
        url + '/tipos-gastos' + this.serialize(this.form),
        "_blank"
      ); 
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    eliminar: function (tipoGasto) {
      swal({
        title: "¿Deseas anular el tipo de movimiento seleccionado?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(`${this.path}/${tipoGasto.codigo}`, {
              _method: "DELETE",
            })
            .then(() => {
              swal(
                "El tipo de movimiento ha sido anulado exitósamente.",
                "Realizado",
                "success"
              );
              this.$refs.tipoGasto.loadRows();
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
  },

  mounted: function () {
    this.cargarDatos();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/administrativo/ListaTipoGasto.vue